/* eslint-disable */
const Logger = {
    debug() {
        console.debug(...arguments);
    },
    info() {
        console.info(...arguments);
    },
    warn() {
        console.warn(...arguments);
    },
    error() {
        console.error(...arguments);
    }
};
export default Logger



